module.exports = __webpack_public_path__ + "static/img/icon-mask2.c633a50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-mask2.png
// module id = /plL
// module chunks = 0